import * as React from "react";
import Grid from '@material-ui/core/Grid';
import Loading, { LoadingInfo } from "common/components/controls/Loading";
import Error from "common/components/controls/Error";
import { Payment } from "common/api/Payments";
import SeznamPlatebItem from "./SeznamPlatebItem";

interface SeznamPlatebProps {
    idtClena: number;
    showPaymentInfo: (p: Payment) => void;
    paymentInfoIsVisible: boolean;
    loadingInfo: LoadingInfo;
    payments?: Payment[];
}

class SeznamPlateb extends React.PureComponent<SeznamPlatebProps> {

    render() {
        const { payments, showPaymentInfo, paymentInfoIsVisible } = this.props;
        const { loading, hasError, error } = this.props.loadingInfo;

        return loading
            ? <Loading loading={loading} />
            : hasError
                ? <Error>{error}</Error>
                : <Grid container direction="column" justify="flex-start" spacing={8}>
                    {payments.map(p => <SeznamPlatebItem key={p.id} payment={p} showPaymentInfo={showPaymentInfo} paymentInfoIsVisible={paymentInfoIsVisible} />)}
                </Grid>;
    }
}


export default SeznamPlateb;
